import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchBox.css';

function SearchBox() {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log(searchQuery);
      if (searchQuery.trim()) {
        console.log(`/search?searchQuery=${searchQuery}`);
        navigate(`/search/${searchQuery}`);
      }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleSubmit(e);
        }
    };

    return (
      <div className="search-box-container">
        <form className="search-box" onSubmit={handleSubmit}>
            <textarea 
            type="text" 
            placeholder="Outline your China travel goals here..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            />
            <div className="search-box-button-container">
                <button type="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="20">
                    <path d="M13 5.41V21h-2V5.41L5.41 11 4 9.59 12 1.59l8 8L18.59 11 13 5.41z"/>
                    </svg>
                </button>
            </div>
        </form>
      </div>
    );
}

export default SearchBox;